import React from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { Link } from "react-router-dom";

const ProductList = ({ products }) => {
  return (
    <div className="grid md:mx-36 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 mt-4">
      {products.map((product) => (
        <div
          key={product.id}
          className="   shadow transition-transform transform hover:scale-105 bg-white"
        >
          <Link to={`/product/${product._id}`} className="block">
            <div className="relative md:h-36 lg:h-48 h-40 overflow-hidden ">
              <img
                width={600}
                height={600}
                className="lg:w-full lg:h-full h-36 md:h-36 object-cover"
                src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                alt={product.name}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-40">
                {" "}
              </div>
            </div>
          </Link>
          <div className="mt-2 p-2">
            <p className="text-lg font-heading text-black mb-2">
              {product.name}
            </p>
            <p className="text-red-500 text-sm font-semibold flex">
              NPR:{product.price}
              {product.originalprice && (
            <p className="text-red-500 text-sm font-semibold line-through" >
            {product.originalprice}
              </p>
            )}
              {product.discountprice && (
            <p className="text-green-500 ml-3 text-sm font-semibold">
            {product.discountprice}
              </p>
            )}
            </p>
            
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductList;
